import { Dropdown } from '../../../../../../../components';
import { inMobile, useWindowDimensions } from '../../../../../../../hooks/useDimensions';
import ZIndexLayers from '../../../../../../../services/ZIndexLayers';
import { Organization } from '../../../../../../../types/api.graphql';
import {
  Container,
  SelectedFromOrgHeaderContainer,
  SelectedOrgLabel,
  StyledGreyInfoIcon,
  StyledTextTooltip,
} from './OrganizationDropdown.styles';

interface OrganizationDropdownProps {
  availableOrganizations: Array<Organization>;
  selectedOrganization?: Organization;
  setSelectedOrganization: (organization: Organization) => void;
  disableDropdown?: boolean;
  label?: string;
  infoTooltip?: string;
}

const OrganizationDropdown = ({
  availableOrganizations,
  selectedOrganization,
  setSelectedOrganization,
  disableDropdown,
  label,
  infoTooltip,
}: OrganizationDropdownProps) => {
  const { width } = useWindowDimensions();

  return (
    <Container>
      <SelectedFromOrgHeaderContainer>
        <SelectedOrgLabel>{label}</SelectedOrgLabel>
        {!!infoTooltip && (
          <StyledTextTooltip
            tooltipText={infoTooltip}
            $zIndex={ZIndexLayers.overModal}
            $maxWidth={inMobile(width) ? '10.313rem' : '13.313rem'}
            $noMarginTop
          >
            <StyledGreyInfoIcon />
          </StyledTextTooltip>
        )}
      </SelectedFromOrgHeaderContainer>
      <Dropdown
        displayRadioIcon={false}
        selectedIndex={
          selectedOrganization ? availableOrganizations?.findIndex((org) => org.id === selectedOrganization?.id) : 0
        }
        items={availableOrganizations?.map((org) => ({
          label: org.name,
          value: org.id,
          text: org.name,
          imageUrl: org.imageUrl,
        }))}
        disabled={disableDropdown}
        onSelectionChange={(index) => setSelectedOrganization(availableOrganizations[index as number])}
      />
    </Container>
  );
};

export default OrganizationDropdown;
